import React, { useRef, useState } from 'react'
import { Text, Checkbox, Dropdown } from '@wework/dieter-ui'
import { useOnClickOutside } from '../../utils/useOnClickOutside'

function ViewOptionsBarContent({ onValueChange, viewOptions, disabled }) {
  const options = [
    {
      key: 'occupancy',
      text: 'Occupancy',
      value: 'occupancy',
    },
    {
      key: 'deskLayout',
      text: 'Desk Layout',
      value: 'deskLayout',
    },
    {
      key: 'deskCount',
      text: 'Desk Count',
      value: 'deskCount',
    },
    {
      key: 'spaceList',
      text: 'Space List',
      value: 'spaceList',
    },
    {
      key: 'hoverPreview',
      text: 'Hover Preview',
      value: 'hoverPreview',
    },
  ]

  const handleValueChange = (key, value) => {
    onValueChange(key, value)
  }

  // handleClickAway = () => {
  //   this.setState({
  //     anchorEl: null,
  //     isPopperOpened: false,
  //   })
  // }

  // const { classes, viewOptions } = this.props
  // const { anchorEl, isPopperOpened } = this.state
  const ref = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  useOnClickOutside(ref, () => setIsOpen(false))
  return (
    <div ref={ref}>
      <Dropdown
        open={isOpen}
        text="Map Views"
        floating
        style={{ marginLeft: 4 }}
        button
        basic
        onClick={() => setIsOpen(true)}
      >
        <Dropdown.Menu style={{ width: 300 }}>
          <Dropdown.Header content="Map view options" />
          {options.map(option => {
            return (
              <Dropdown.Item
                key={option.key}
                disabled={disabled}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 16,
                }}
              >
                <Text>{option.text}</Text>
                <Checkbox
                  toggle
                  checked={viewOptions[option.key]}
                  onChange={(e, data) => {
                    handleValueChange(option.value, data.checked)
                  }}
                  value={option.value}
                  color="primary"
                />
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
    // <Select as={Input} placeholder="Map views" options={options} floating />
  )
  // <ClickAwayListener onClickAway={this.handleClickAway}>
  //   <div className={classes.viewToolbar}>
  //     <Text size="small" style={{ marginRight: 6 }}>
  //       Customize your view
  //     </Text>
  //     <Button
  //       basic
  //       onClick={this.openPopover}
  //       size="small"
  //       style={{
  //         display: 'flex',
  //         flexDirection: 'row',
  //         alignItems: 'center',
  //         justifyContent: 'space-around',
  //       }}
  //     >
  //       Map information
  //       <Icon style={{ marginLeft: 4 }} name="caret down" />
  //     </Button>
  //     <Popper
  //       open={isPopperOpened}
  //       anchorEl={anchorEl}
  //       onClose={this.closePopover}
  //       placement="bottom-start"
  //       disablePortal
  //       transition
  //     >
  //       {({ TransitionProps }) => (
  //         <Fade {...TransitionProps} timeout={350}>
  //           <Paper style={{ overflow: 'hidden' }}>
  //             <div>
  //               <List
  //                 subheader={
  //                   <Text
  //                     style={{
  //                       color: '#ACA3B8',
  //                       fontSize: '0.7rem',
  //                       lineHeight: '1rem',
  //                       marginTop: '1rem',
  //                       marginRight: 4,
  //                     }}
  //                   >
  //                     Information on Floor Map
  //                   </Text>
  //                 }
  //                 className={classes.root}
  //               >
  //                 <ListItem>
  //                   <Text size="small">Desk Count</Text>
  //                   <ListItemSecondaryAction
  //                     classes={{ root: classes.secondaryActions }}
  //                   >
  //                     <Checkbox
  //                       slider
  //                       checked={deskCount}
  //                       onChange={this.handleValueChange('deskCount')}
  //                     />
  //                   </ListItemSecondaryAction>
  //                 </ListItem>
  //                 <ListItem>
  //                   <Text size="small">Desk Layout</Text>
  //                   <ListItemSecondaryAction
  //                     classes={{ root: classes.secondaryActions }}
  //                   >
  //                     <Checkbox
  //                       slider
  //                       checked={deskLayout}
  //                       onChange={this.handleValueChange('deskLayout')}
  //                     />
  //                   </ListItemSecondaryAction>
  //                 </ListItem>
  //                 <ListItem>
  //                   <Text size="small">Occupancy</Text>
  //                   <ListItemSecondaryAction
  //                     classes={{ root: classes.secondaryActions }}
  //                   >
  //                     <Checkbox
  //                       slider
  //                       checked={occupancy}
  //                       onChange={this.handleValueChange('occupancy')}
  //                     />
  //                   </ListItemSecondaryAction>
  //                 </ListItem>
  //                 <ListItem>
  //                   <Text size="small">Space List</Text>
  //                   <ListItemSecondaryAction
  //                     classes={{ root: classes.secondaryActions }}
  //                   >
  //                     <Checkbox
  //                       slider
  //                       checked={spaceList}
  //                       onChange={this.handleValueChange('spaceList')}
  //                     />
  //                   </ListItemSecondaryAction>
  //                 </ListItem>
  //               </List>
  //               <List
  //                 subheader={
  //                   <Text
  //                     style={{
  //                       color: '#ACA3B8',
  //                       fontSize: '0.7rem',
  //                       marginRight: 4,
  //                       lineHeight: '1rem',
  //                     }}
  //                   >
  //                     Pop-up space detail
  //                   </Text>
  //                 }
  //                 className={classes.root}
  //               >
  //                 <ListItem>
  //                   <Text size="small">Hover to see space detail pop-up</Text>
  //                   <ListItemSecondaryAction
  //                     classes={{ root: classes.secondaryActions }}
  //                   >
  //                     <Checkbox
  //                       slider
  //                       checked={hoverPreview}
  //                       onChange={this.handleValueChange('hoverPreview')}
  //                     />
  //                   </ListItemSecondaryAction>
  //                 </ListItem>
  //               </List>
  //             </div>
  //           </Paper>
  //         </Fade>
  //       )}
  //     </Popper>
  //   </div>
  // </ClickAwayListener>
}

export default ViewOptionsBarContent
